import { User } from 'generated-graphql/types';

export const getUserContactEmail = (user: User) =>
  user.correspondenceEmail || user.email;
